import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
  ChartOptions,
} from "chart.js";
import { toPersianNumber } from "@/hooks/useThousandsSeparator";
import moment from "jalali-moment";

// ثبت پلاگین‌ها
ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

type ColumnChartProps = {
  categories: string[];
  series: {
    name: string;
    data: number[];
  }[];
  barWidth?: string;
  colors?: string[];
};

const ColumnChart = (props: ColumnChartProps) => {
  const { categories, series, barWidth = "50%", colors } = props;
  const data = {
    labels: categories.map((date) => date),
    datasets: series.map((s, i) => ({
      label: s.name,
      data: s.data,
      backgroundColor: colors?.[i] || `rgba(0, 123, 255, 0.7)`,
      borderRadius: 5,
      barPercentage: parseFloat(barWidth) / 100,
    })),
  };

  const options: ChartOptions<"bar"> = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      tooltip: {
        callbacks: {
          label: (context) => {
            const value = context.raw as number;
            return `${toPersianNumber(value.toLocaleString("fa-IR"))} زار ریال`;
          },
        },
        titleFont: {
          family: 'vaziriFont, "B Yekan", Tahoma, Arial, sans-serif',
        },
        bodyFont: {
          family: 'vaziriFont, "B Yekan", Tahoma, Arial, sans-serif',
        },
      },
      legend: {
        labels: {
          usePointStyle: true,
          font: {
            size: 14,
            family: 'vaziriFont, "B Yekan", Tahoma, Arial, sans-serif',
          },
          color: "#fff",
        },
      },
    },
    scales: {
      x: {
        ticks: {
          font: {
            size: 14,
            family: 'vaziriFont, "B Yekan", Tahoma, Arial, sans-serif',
          },
          color: "#fff",
        },
      },
      y: {
        min: 0,
        max: 100,
        ticks: {
          stepSize: 20,
          callback: function (value: any) {
            return toPersianNumber(Math.round(value).toLocaleString("fa-IR"));
          },
          color: "#fff",
        },
      },
    },
  };

  return (
    <div style={{ height: "350px" }}>
      <Bar data={data} options={options} />
    </div>
  );
};

export default ColumnChart;
